import { render } from "./NotificationPage.vue?vue&type=template&id=7b03f405&scoped=true"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"

import "./NotificationPage.vue?vue&type=style&index=0&id=7b03f405&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b03f405"]])

export default __exports__